import React, { useState, useEffect } from 'react';

import { getval2Token, setVal2Token } from '../../../Login/Auth';
import { SingleText } from '../../Res/BaseInput';
import { getCaseStatusString } from '../../../../item/ItemRecruitmentContractorStatus';
import { ReqRecruitmentContractorCaseInfo, VIEW_RESIGN_TO_ONBOARD, VIEW_CASESTATUS3, VIEW_RESIGNDATE, VIEW_CASESTATUS4 } from '../../../../item/ItemRecruitmentContractor';
import { ContentBox } from '../ContentBox';
import { SingleBigButton } from '../../Res/BaseButton';
import Swal from 'sweetalert2';
import moment from 'moment';
import { ReviseOnBoard2Reserve } from './ReviseOnBoard2Reserve';
import { ReviseResignDate } from './ReviseResignDate';
import { ReviseResign2OnBoard } from './ReviseResign2OnBoard';



export function ReviseSOPCaseStatus4({ id, setIsLoading, isEdit = false }) {
  const [tokenId, setTokenId] = useState("")
  const [item, setItem] = useState(null)

  const [vw_status, set_vw_status] = useState(<></>)
  const [content, setContent] = useState(<></>)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var item = getval2Token("ReviseSOPCaseStatus4", id)
      // console.log(item)
      setTokenId(id)
      setItem(item)
      var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
      mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
      set_vw_status(
        <>
          <SingleText title={"目前的 案件狀態"} val={item.caseContractorName + " " + getCaseStatusString(item, mReqRecruitmentContractorCaseInfo)} />
          <SingleText title={"當時的 預定上工日"} val={moment(mReqRecruitmentContractorCaseInfo.caseReserveDate).format('YYYY/MM/DD')} />
          <SingleText title={"當時的 案件管轄者"} val={item.caseOwnerName} />
        </>
      )
      //setContent(<ReviseView item={item} caseContractorName={caseContractorName} caseStatus={caseStatus} statusDate={statusDate} caseOwnerName={caseOwnerName} action={change} />)
    }
  }, [id])

  useEffect(() => {
    if (item !== null && tokenId !== null) {
      var view = getval2Token("view", tokenId)
      // console.log(view||VIEW_CASESTATUS1)
      change(view)
    }
  }, [item, tokenId])

  function change(val) {
    // console.log(item)
    switch (val) {
      case VIEW_RESIGNDATE:
        setContent(<ReviseResignDate item={item} action={change} vw_status={vw_status} setIsLoading={setIsLoading} />)
        break;
      case VIEW_RESIGN_TO_ONBOARD:
        // console.log(typeof recruitmentContractorStatusItem.contractorJobStatus)
        // if (recruitmentContractorStatusItem.contractorJobStatus + "" === JOB_STATUS_ONBOARD) {
        //   Swal.fire({
        //     type: 'error',
        //     title: '外派員工已“上工”',
        //   })
        //   return
        // }
        setContent(<ReviseResign2OnBoard item={item} action={change} vw_status={vw_status} setIsLoading={setIsLoading} />)
        break;
      default:
        setContent(<ReviseView item={item} action={change} vw_status={vw_status} />)
        break;
    }
    setVal2Token('view', val, tokenId)
  }

  return (
    <>{content}</>
  )

}

function ReviseView({ item, action, vw_status }) {
  const [mItem, setItem] = useState({})
  useEffect(() => {
    if (item !== undefined && item !== mItem) {
      console.log(item)
      setItem(item)
    }
  }, [item])


  function toResignDate() {
    action(VIEW_RESIGNDATE)
  }
  function toReserve() {
    action(VIEW_RESIGN_TO_ONBOARD)
  }

  var superTitle = "請選擇要進行哪一種修正方式"
  var title = ""
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          {vw_status}
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"校正 “下工日””"} action={toResignDate} />

          <div className="col-md-9">
            <p className="col-md-12">
            提示：修正“上工日”，可能會影響退保日期，務必自行追蹤！</p>
          </div>
        </div>
      </div>
      <div className="hr-line-dashed"></div>

      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"從“已離職” 改為 “上工中”"} action={toReserve} size={3} />


          <div className="col-md-9">
            <p className="col-md-12">
            提示：主要是復原案件在，招募員誤按“確定離職”的情況。</p>
            <p className="col-md-12">
            注意：會影響待退保人員清單，務必自行追蹤！</p>
          </div>
        </div>
      </div >
      
    </>

  return (
    <>
      <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} hasDrawer={false} />
    </>
  )
}

